const component = {
  templateUrl: '/core/components/upload-table/upload-table.html?$$REVISION$$',
  bindings: {
    files: '<',
    abort: '&'
  },
  controllerAs: '$ctrl',
  controller: () => {
    var ctrl = this // eslint-disable-line no-unused-vars
  }
}

export const uploadTable = component
